import { forwardRef } from "react";
import { Navigate } from "react-router-dom";
import { useIsAdmin } from "@/hooks/useUserRole";

const AdminRoute = forwardRef<HTMLDivElement, { children: React.ReactNode }>(({ children }, ref) => {
  const { isAdmin, isLoading } = useIsAdmin();

  if (isLoading) {
    return (
      <div ref={ref} className="min-h-[60vh] flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
          <span className="text-sm text-muted-foreground">Checking permissions...</span>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <div ref={ref}>{children}</div>;
});

AdminRoute.displayName = "AdminRoute";

export default AdminRoute;
